export const APP_VERSION = "3.19.7";
